import type { Graph } from '@/schema/estate';

export async function createEstate(
  g: Graph,
  opts: { name: string; author: string; groupId: string },
): Promise<string> {
  const id = crypto.randomUUID();
  const now = Date.now();
  await g.estate.create({
    id,
    owner_group_id: opts.groupId,
    name: opts.name,
    description: '',
    default_currency: 'USD',
    status: 'active',
    created_by: opts.author,
    created_at: now,
    updated_at: now,
    archived: false,
  });
  return id;
}

export function listEstates(g: Graph) {
  return g.estate.all().filter((e) => !e.archived);
}

export async function archiveEstate(g: Graph, id: string): Promise<void> {
  await g.estate.update(id, { archived: true, updated_at: Date.now() });
}
